module.exports = __webpack_public_path__ + "static/media/ai-star-loading.0771b912.gif";